import axios from 'axios';

const createAutomation = () => {
    return axios.get('/automations/new');
};

const deleteAutomation = (id) => {
    return axios.delete(`/automations/flows/${id}`);
};

const disableAutomation = (id) => {
    return axios.patch(`/automations/flows/${id}/disable`);
};

const duplicateAutomation = (id) => {
    return axios.post(`/automations/flows/${id}/duplicate`);
};

const enableAutomation = (id) => {
    return axios.patch(`/automations/flows/${id}/enable`);
};

const getAutomations = () => {
    return axios.get('/automations/flows');
};

const getAutomationsTemplates = () => {
    return axios.get('/automations/flow-templates');
};

const useAutomationTemplate = (id, formData = {}) => {
    return axios.post(`/automations/flow-templates/${id}/use`, formData);
};

const getAutomationPieces = (pieceNames) => {
    return axios.post('/automations/pieces', {
        pieces: pieceNames,
    });
};

const getPipelines = () => {
    return ApiClient.get('/opportunities/pipelines');
};

const getPipelineSteps = (pipelineId) => {
    return ApiClient.get(`/opportunities/pipelines/${pipelineId}/steps`);
};

const renameAutomationFlow = (id, formData = {}) => {
    return axios.post(`/automations/flows/${id}/rename`, formData);
};

export {
    createAutomation,
    deleteAutomation,
    disableAutomation,
    duplicateAutomation,
    enableAutomation,
    getAutomations,
    getAutomationPieces,
    getAutomationsTemplates,
    getPipelines,
    getPipelineSteps,
    renameAutomationFlow,
    useAutomationTemplate,
};
